import supportedLocales from '@/config/supported-locales';

export function getSupportedLocales() {
  const annotatedLocales = [];

  for (const code of Object.keys(supportedLocales)) {
    annotatedLocales.push({
      code,
      name: supportedLocales[code].shortName,
      shortName: supportedLocales[code].shortName,
      longName: supportedLocales[code].longName,
      localName: supportedLocales[code].localName,
      customName: supportedLocales[code].customName,
      flag: supportedLocales[code].flag,
    });
  }

  return annotatedLocales;
}

export function supportedLocalesInclude(locale) {
  return Object.keys(supportedLocales).includes(locale);
}
